export const signup = {
  _root: "/signup",
  confirmEmail: "/confirm-email",
  signupSuccess: "/signup-success",
  activateUser: "/activate-user"
};
